import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';

import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';

function Login(): JSX.Element {
  const { ssoLogin } = useAuth();
  const { apiHost } = useConfig();

  const loginWithSSO = () => {
    ssoLogin(apiHost);
  };

  return (
    // centered MUI box
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Stack direction="column" alignItems="center">
        <Typography variant="h4">Welcome to the OneDSP</Typography>
        <br />
        {/* left justify */}
        <Box sx={{ marginLeft: '50px', width: '100%', textAlign: 'left' }}>
          <Typography variant="h5">Please sign in to continue:</Typography>
        </Box>
        <Box sx={{ width: '100%' }} p={3}>
          <Stack spacing={2} direction="column">
            <Button variant="contained" color="primary" onClick={loginWithSSO}>
              Login with SSO
            </Button>
          </Stack>
        </Box>
        <Box sx={{ marginLeft: '50px', width: '100%', textAlign: 'left' }}>
          <Typography variant="body1">Not registered yet?</Typography>
          <Typography variant="body2">
            Please contact your Thinknear Account Manager for registration details.
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

export default Login;
